import React from "react";
import Routes from "./Routes";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import { Router} from "react-router-dom";
import history from './history'
import{GenerateAIMSToken} from "./app/components/base/helper/authHelper"
import "./index.css"
const store = configureStore();

ReactDOM.render(
  <Router history={history}>
    <Provider store={store}>
    <Routes />
    </Provider>
  </Router>,
  document.getElementById("root")
);
GenerateAIMSToken();
export default store;